module.exports = __webpack_public_path__ + "img/shepherds.08b5c67b.svg";